import React from "react";

import { IconButton } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import MealRatingIcon from "./MealRatingIcon";

interface Props {
  className?: string;
  rating?: number | null;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
}

const MealRatingButton: React.FC<Props> = ({
  className,
  rating,
  onClick,
  selected,
  disabled,
}) => {
  const { classes, cx } = useStyles();

  if (rating == null) {
    return <span>-</span>;
  }

  return (
    <IconButton
      className={cx(classes.root, selected && classes.selected, className)}
      onClick={onClick}
      disabled={disabled}
    >
      <MealRatingIcon className={classes.icon} rating={rating} />
    </IconButton>
  );
};

const useStyles = makeStyles()({
  root: {
    width: 36,
    height: 36,
    border: "1px solid #EEE",
  },
  selected: {
    borderColor: "orange",
  },
  icon: {
    maxWidth: 24,
    maxHeight: 24,
  },
});

export default MealRatingButton;
